import React from "react";
import Grid from "@mui/material/Grid2"; // שימוש ב-Grid v2
import { Box, Typography, Paper } from "@mui/material";
import { Product, RepresentativeInfo } from "../../../interfaces/DTO/mislaka_xml_models";
import { formatYesNo } from "../../../utils/pensionEnumFormatter";
import { formatIsoDate } from "../../../utils/namesFormater";
import { formatIdentificationType, formatPolicyEmploymentStatus, formatPolicyTypeCategory, formatRepresentativeType } from "../../../utils/enumFormatter";



interface PolicyMetadataProps {
  product: Product;
}

const PolicyMetadata: React.FC<PolicyMetadataProps> = ({ product }) => {
  const policy = product.policies_or_accounts[0];

  if (!policy) {
    return <Typography color="error">לא נמצאו נתוני פוליסה</Typography>;
  }

  const representatives: RepresentativeInfo[] = policy.representative_info || [];

  return (
    <Box sx={{ p: 2 }}>
      {/* פרטי פוליסה */}
      <Typography variant="h6" gutterBottom>פרטי פוליסה</Typography>
      <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">מספר פוליסה:</Typography></Grid>
          <Grid size={{ xs: 6, md: 8 }}><Typography>{policy.policy_number || "-"}</Typography></Grid>

          <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">תאריך פתיחה:</Typography></Grid>
          <Grid size={{ xs: 6, md: 8 }}><Typography>{formatIsoDate(policy.join_date) || "-"}</Typography></Grid>

          <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">תאריך הצטרפות למוצר:</Typography></Grid>
          <Grid size={{ xs: 6, md: 8 }}><Typography>{formatIsoDate(policy.product_join_date) || "-"}</Typography></Grid>

        
          <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">שם התוכנית:</Typography></Grid>
          <Grid size={{ xs: 6, md: 8 }}><Typography>{policy.program_name || "-"}</Typography></Grid>

          <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">קטגוריית פוליסה:</Typography></Grid>
          <Grid size={{ xs: 6, md: 8 }}><Typography>{formatPolicyTypeCategory(policy.policy_type_category) || "-"}</Typography></Grid>

          <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">סוג תוכנית/חשבון:</Typography></Grid>
          <Grid size={{ xs: 6, md: 8 }}><Typography>{formatPolicyEmploymentStatus(policy.plan_or_account_type) || "-"}</Typography></Grid>

          <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">תאריך עדכון:</Typography></Grid>
          <Grid size={{ xs: 6, md: 8 }}><Typography>{formatIsoDate(policy.update_date) || "-"}</Typography></Grid>

          <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">מספר סוכן:</Typography></Grid>
          <Grid size={{ xs: 6, md: 8 }}><Typography>{policy.agent_id_for_producer || "-"}</Typography></Grid>
        </Grid>
      </Paper>

      {/* פרטי סוכן */}
      {representatives.length > 0 && (
        <>
          <Typography variant="h6" gutterBottom>פרטי סוכן</Typography>
          {representatives.map((representative, index) => (
            <Paper key={index} elevation={2} sx={{ p: 2, backgroundColor: "#f5f5f5", mb: 2 }}>
              <Typography variant="subtitle1">מיופה כוח {index + 1}</Typography>
              <Grid container spacing={2}>
                <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">קיים מיופה כוח:</Typography></Grid>
                <Grid size={{ xs: 6, md: 8 }}><Typography>{formatYesNo(representative.power_of_attorney_exists)}</Typography></Grid>

                <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">סוג זיהוי:</Typography></Grid>
                <Grid size={{ xs: 6, md: 8 }}><Typography>{formatIdentificationType(representative.identification_type)}</Typography></Grid>

                <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">סוג מיופה כוח:</Typography></Grid>
                <Grid size={{ xs: 6, md: 8 }}><Typography>{formatRepresentativeType(representative.representative_type)}</Typography></Grid>

                <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">הרשאה לביצוע פעולה:</Typography></Grid>
                <Grid size={{ xs: 6, md: 8 }}><Typography>{formatYesNo(representative.authorization_for_action)}</Typography></Grid>

                <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">מספר זיהוי:</Typography></Grid>
                <Grid size={{ xs: 6, md: 8 }}><Typography>{representative.identification_number || "-"}</Typography></Grid>

                <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">תאריך מינוי סוכן:</Typography></Grid>
                <Grid size={{ xs: 6, md: 8 }}><Typography>{formatIsoDate(representative.appointment_date) || "-"}</Typography></Grid>

                <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">שם מיופה כוח:</Typography></Grid>
                <Grid size={{ xs: 6, md: 8 }}><Typography>{representative.representative_name || "-"}</Typography></Grid>

                <Grid size={{ xs: 6, md: 4 }}><Typography variant="body2">תאריך תום ייפוי כח:</Typography></Grid>
                 <Grid size={{ xs: 6, md: 8 }}><Typography>{formatIsoDate(representative.expire_appointment_date) || "-"}</Typography></Grid>
              </Grid>
            </Paper>
          ))}
        </>
      )}
    </Box>
  );
};

export default PolicyMetadata;
